import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-comments-summary',
  templateUrl: './comments-summary.component.html',
  styleUrls: ['./comments-summary.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CommentsSummaryComponent implements OnInit {

  @Input() comments: [];
  @Input() id: string;
  @Input() data: any;
  @Output() commentsSummary: EventEmitter<any> = new EventEmitter();

  summaryText: string;

  constructor() { }

  ngOnInit() {
    //this.getCommentsSummary();
  }

  // getCommentsSummary() {
  //   // if (this.comments && this.comments.length >= 1) {
  //   //   this.summaryText = this.comments.length + " Comments";
  //   // } else{
  //   //   this.summaryText = "";
  //   // }
  //   this.summaryText = this.comments ? this.comments.length + " Comments" : "";
  // }

  onCommentsSummary() {
    const id = this.id
    const payload = this.data
    this.commentsSummary.emit({
      id,
      payload
    });
  }

}
